import { NotificationCategories } from '../interfaces/notification.interface';

export const CategoryColorMap = {
  [NotificationCategories.MaintenanceNotice]: '#FF2F00',
  [NotificationCategories.ReleaseNotes]: '#FFAA06',
  [NotificationCategories.GeneralInformation]: '#0B6BCB',
  [NotificationCategories.BannedUser]: '#FF2F00'
};

export const ALL_NOTIFICATIONS_CATEGORIES_KEY = 'all';
